/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_SubtitleInputs */

const cs_auth_reset_subtitle = /** @type {(inputs: Auth_Reset_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Než budete pokračovat, musíte si nastavit nové heslo.`)
};

const en_auth_reset_subtitle = /** @type {(inputs: Auth_Reset_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account requires a new password before you can continue.`)
};

/**
* | output |
* | --- |
* | "Your account requires a new password before you can continue." |
*
* @param {Auth_Reset_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_subtitle = /** @type {((inputs?: Auth_Reset_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_subtitle(inputs)
	return cs_auth_reset_subtitle(inputs)
});